import { type FC } from 'react'
import { Link } from 'react-router-dom'
import { useIntercom } from 'react-use-intercom'

export const MeetingPlatformWarning: FC<{ showSupportLink?: boolean }> = ({ showSupportLink = false }) => {
  const { show: showSupport } = useIntercom()
  return (
    <div className='d-flex align-items-start gap-3 px-3 py-2 rounded-3 zocks-border-color-warning-dark zocks-bg-color-white'>
      <i className='bi bi-exclamation-triangle-fill zocks-text-warning-dark' aria-hidden='true' />
      <div className='d-flex flex-column'>
        <div className='paragraph-medium bold zocks-text-gray-900'>Meetings will not get a join link.</div>
        <div className='paragraph-small zocks-text-gray-900'>
          You can send invites and add a link later, or{' '}
          <Link to='/account/profile-settings/scheduling?section=integrations' className='zocks-text-primary text-decoration-underline'>
            reconnect
          </Link>{' '}
          your meeting platform.
          {showSupportLink ? (
            <>
              {' '}
              <button
                type='button'
                className='bg-transparent p-0 border-0 align-baseline paragraph-small zocks-text-primary text-decoration-underline'
                onClick={() => showSupport()}
              >
                Contact support
              </button>{' '}
              if the problem continues.
            </>
          ) : null}
        </div>
      </div>
    </div>
  )
}
